
import { Badge } from "@/components/ui/badge";

interface AdminEditListingHeaderProps {
  listing: {
    name: string;
    status: string;
  };
  isCreating?: boolean;
}

const AdminEditListingHeader = ({ listing, isCreating = false }: AdminEditListingHeaderProps) => {
  const getStatusBadge = (status: string) => {
    switch (status) {
      case "approved":
        return <Badge className="bg-green-100 text-green-800">Approved</Badge>;
      case "pending":
        return <Badge className="bg-yellow-100 text-yellow-800">Pending</Badge>;
      case "rejected":
        return <Badge className="bg-red-100 text-red-800">Rejected</Badge>;
      default:
        return <Badge className="bg-gray-100 text-gray-800">{status}</Badge>;
    }
  };

  return (
    <div className="mb-6">
      {!isCreating && (
        <div className="flex items-center space-x-3">
          <span className="text-lg font-medium text-gray-700">{listing.name}</span>
          {getStatusBadge(listing.status)}
        </div>
      )}
    </div>
  );
};

export default AdminEditListingHeader;
